import React from 'react'
import PropTypes from 'prop-types'
import Image from 'react-image'
import { LogoBlack } from 'constants/imageMapping';
import NoImage from 'assets/images/no-image.jpg'
import ThumbnailLoader from 'components/shared/loaders/thumb'
import groupBy from 'lodash/groupBy'
import map from 'lodash/map'
import Modal from 'components/shared/modal'

const MoreSpacesSelection = ({ onClose, spaces, selectSpace, selected }) => {
  const renderHeader = (<div className="py-2"><a href="/" className="py-6">
    <img alt="logo" src={LogoBlack} className="w-32"/>
  </a></div>)
  return (
    <Modal header={renderHeader} className="bg-white w-full rounded shadow-lg z-50 min-h-screen" onClose={onClose}
      style={{ margin: 0 }}>
      <div className="w-full">
        <div
          className="flex flex-col bg-white lato-reg overflow-auto"
          style={{ maxHeight: 600 }}
          onClick={e => {
            e.stopPropagation()
            if (e.target !== e.currentTarget) {
              // TODO
              onClose()
            }
          }}
        >
          {map(groupBy(spaces, 'category.name'), (item, key) => (
            <ul className="border-b" key={key}>
              <p className="text-xl text-gray-800 font-semibold mb-3">{`${key}` !== 'undefined' ? key : ''}</p>
              {item.map(space => {
                const {
                  id,
                  title,
                  thumbnail: { src, alt },
                  link,
                  prices,
                  capacity,
                } = space
                return (
                  <li
                    className={`flex flex-row justify-between w-full lg:w-11/12 lg:items-center mb-5 lg:pr-5 ${selected.id ===
                    id && 'text-primary-orange'}`}
                    key={id}
                  >
                    <div className="relative mr-3 w-20 md:w-24 h-20 md:h-24">
                      <Image
                        src={[src, NoImage]}
                        alt={alt}
                        className="rounded object-cover h-full w-full"
                        loader={<ThumbnailLoader/>}
                      />
                    </div>
                    <div className="flex flex-row flex-1">
                      <div className="flex flex-col lg:flex-row w-full justify-start lg:justify-around">
                        <div className="flex flex-col items-start lg:flex-1 lg:py-2">
                          <p
                            href={link}
                            className={`mb-1 font-medium text-sm hover:text-primary-orange cursor-pointer`}
                            onClick={() => selectSpace(space)}
                          >
                            {title}
                          </p>
                          <p
                            className={`capacity text-sm lg:py-2 ${
                              selected.id === id ? 'text-primary-orange' : 'text-primary-lightgray'}`}
                          >
                            {capacity}
                          </p>
                        </div>
                        <div className="prices w-32 lg:mx-3 lg:text-center text-sm lg:py-2">
                          <ul>
                            {prices.map((price, key) => (
                              <li key={key}>
                                <span>{price.amount}</span>
                                <span
                                  className={`${
                                    selected.id === id
                                      ? 'text-primary-orange'
                                      : 'text-primary-lightgray'}`}
                                >{` /${price.type}`}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="px-2">
                      {selected.id === id && (
                        <i className="my-1 fa fa-check text-primary-orange" aria-hidden="true"/>
                      )}
                    </div>
                  </li>
                )
              })}
            </ul>
          ))}
        </div>
      </div>
    </Modal>
  )
}

MoreSpacesSelection.propTypes = {
  spaces: PropTypes.array,
  selected: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  selectSpace: PropTypes.func.isRequired,
}

export default MoreSpacesSelection
